import styled, { css } from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../3rdPartyModules/_react-aria/focus/dist/useFocusRing-DPVmdx21.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../3rdPartyModules/_react-aria/utils/dist/mergeProps-CTIwukXV.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { f as focusOutline } from '../FocusIndicator/styleMixins/focusOutline-DNwtedBp.js';
import { I as Icon } from '../Icon/Icon-Dg8OkmbZ.js';

const CloseIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30078624__sc-1saaji8-0"
})(["font-size:13px;padding:", " ", ";color:", ";", " :hover{color:", ";cursor:pointer;}"], ({
  theme
}) => theme.spacing.small, ({
  theme
}) => theme.spacing.micro, ({
  theme
}) => theme.button.close.color, isMobile(css(["font-size:18px;"])), ({
  theme
}) => theme.button.close.colorHover);
CloseIcon.displayName = 'CloseIcon';
const CloseButton = /*#__PURE__*/styled('button').attrs(({
  theme,
  closeButtonLabel,
  ...props
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(props, focusProps),
    tabIndex: '0',
    'aria-label': closeButtonLabel,
    $focusVisible: isFocusVisible,
    type: 'button'
  };
}).withConfig({
  componentId: "sc-storm-ui-30078624__sc-1saaji8-1"
})(["margin-inline-start:", ";border:none;background:transparent;padding:", ";:focus{outline:none;", "}"], ({
  theme
}) => theme.spacing.base, ({
  theme
}) => theme.spacing.none, ({
  $focusVisible
}) => $focusVisible && focusOutline);
CloseButton.displayName = 'CloseButton';

export { CloseButton as C, CloseIcon as a };
//# sourceMappingURL=CloseButton-COOUYdvi.js.map
